<!-- <div id="header" class="py-5 d-flex justify-content-between align-items-center border-left border-right border-top px-4">
    <div class="text-dark-50 font-size-sm font-weight-bolder">Productivity Bar</div>
</div> -->
<div id="productivity-bar-component" class="productivity-bar-common-style-container pr-5">
    <div id="outer-container">
        <div id="percentage-marker-outer-container">
            <div class="percentage-marker-container">
                <div class="percentage-marker">100%</div>
            </div>
            <div class="percentage-marker-container">
                <div class="percentage-marker">75%</div>
            </div>
            <div class="percentage-marker-container">
                <div class="percentage-marker">50%</div>
            </div>
            <div class="percentage-marker-container">
                <div class="percentage-marker">25%</div>
            </div>
        </div>
        <div id="bottom-grey-timeline"></div>

        <div id="timeline-candle-outer-container" [ngClass]="{'bg-transparent': currentViewType === 'week' || currentViewType === 'month'}">
            <ngx-shimmer-loading *ngIf="isLoading"></ngx-shimmer-loading>
            <span *ngIf="!isLoading && productivityData && isDataEmpty()" class="my-auto h-100 justify-content-center text-muted font-size-h3" style="z-index: 90; position: absolute; width:100%; display:flex; align-items:center;">{{'Nodataavailable' | localize}}</span>
            <div id="candle-container" *ngIf="currentViewType === 'day'">
                <div class="candle-segment" *ngFor="let productivityCandleData of productivityData; let i = index" [attr.data-candle-segment-index]="i">
                    <div appCandleSection [sectionType]="2" [candleData]="productivityCandleData" [candleIndex]="i" class="pointer" [ngClass]="{'candle-outline': isInMonthOrWeekView !== true}" id="unproductive-time-candle"></div>
                    <div appCandleSection [sectionType]="3" [candleData]="productivityCandleData" [candleIndex]="i" class="pointer" [ngClass]="{'candle-outline': isInMonthOrWeekView !== true}" id="neutral-time-candle"></div>
                    <div appCandleSection [sectionType]="1" [candleData]="productivityCandleData" [candleIndex]="i" class="pointer" [ngClass]="{'candle-outline': isInMonthOrWeekView !== true}" id="productive-time-candle"></div>
                </div>
            </div>
            <p-chart type="line" [height]="190" [data]="weeklyData" [options]="chartOptions" *ngIf="currentViewType === 'week'"></p-chart>
            <p-chart type="line" [height]="190" [data]="monthlyData" [options]="chartOptions" *ngIf="currentViewType === 'month'"></p-chart>
            <div id="bottom-blue-line-container" #candleBaseContainer>
                <div [appCandleBase]="i"
                     [productivityData]="productivityData"
                     [manualTime]="manualTime"
                     [parentElement]="candleBaseContainer"
                     [productivityBarcomponent]="this"
                     class="time-segment pointer"
                     *ngFor="let timeSegment of timeSegmentArray; let i = index"
                     [attr.data-time-segment-index]="i"
                     [comingFrom]='RealTime'></div>
            </div>
            <div id="time-stamp-container">
                <div class="timeline-bucket" *ngFor="let timelineBucket of timelineBucketsArray; let i = index">
                    <span class="not-last-timestamp timestamp">{{ timelineBucket * 60 | twelveHour: false }}</span>
                    <span class="last-timestamp timestamp" *ngIf="timelineBucketsArray.length - 1 === i">
                        {{
                        (timelineBucket + 1) * 60 | twelveHour: false
                        }}
                    </span>
                </div>
            </div>
        </div>
    </div>
    <div class="d-md-flex justify-content-center align-items-center py-4" id="bottom-legend">
        <div class="d-flex mx-4 align-items-center">
            <div class="legend-badge productive-legend-badge"></div>
            <div class="text-dark-50 ml-4 font-size-sm">{{'Productive' | localize}}</div>
            <div class="text-dark-50 ml-5">{{ meanProductivePercent }} %</div>
        </div>
        <div class="d-flex mx-4 align-items-center">
            <div class="legend-badge unproductive-legend-badge"></div>
            <div class="text-dark-50 ml-4 font-size-sm">{{'Unproductive' | localize}}</div>
            <div class="text-dark-50 ml-5">{{ meanUnproductivePercent }} %</div>
        </div>
        <div class="d-flex mx-4 align-items-center">
            <div class="legend-badge neutral-legend-badge"></div>
            <div class="text-dark-50 ml-4 font-size-sm">{{'Neutral' | localize}}</div>
            <div class="text-dark-50 ml-5">{{ meanNeutralPercent }} %</div>
        </div>
    </div>
</div>

<p-sidebar [(visible)]="isSidebarOpen"
            [blockScroll]="true"
           (onHide)="closeSidePanel()"
           id="productivity-bar-component-sidebar"
           class="productivity-bar-common-style-container"
           styleClass="p-sidebar-md"
           position="right">
    <div class="text-dark-65 font-weight-boldest  font-size-lg h4 pt-1 mb-3">
        {{'Offlinetime' | localize}}

        <button type="button" class="close text-danger fs-2" (click)="closeSidePanel()" aria-label="Close">
            <i aria-hidden="true" class="ki ki-close"></i>
        </button>
    </div>
    <hr />
    <div class="text-dark-65 font-weight-bold mt-6 mb-4">{{'Dragtheslidertofillofflinetimegapsorentertimemanually' | localize}}</div>
    <div class="row mb-4">
        <div class="col">
            <div class="form-group">
                <div class="text-dark-65 mb-2 font-weight-bold">{{'From' | localize}}</div>
                <div class="input-icon input-icon-right">
                    <input type="text" disabled class="form-control text-dark-50" value="{{ sidebarSliderRangeValues[0] | twelveHour: true }}" />
                    <span><i class="flaticon-stopwatch icon-md"></i></span>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="form-group">
                <div class="text-dark-65 mb-2 font-weight-bold">{{'To' | localize}}</div>
                <div class="input-icon input-icon-right">
                    <input type="text" disabled class="form-control text-dark-50" value="{{ sidebarSliderRangeValues[1] | twelveHour: true }}" />
                    <span><i class="flaticon-stopwatch icon-md"></i></span>
                </div>
            </div>
        </div>
    </div>

    <!-- Range slider with step size of 1 min and min and max set as minute values of start time and end time -->
    <p-slider [disabled]="isOfflineTimeApproved" [(ngModel)]="sidebarSliderRangeValues" [range]="true" [step]="5" [min]="0" [max]="currTimeMins" (onSlideEnd)="Check($event)"></p-slider>

    <div class="form-group mb-5 mt-9">
        <div class="text-dark-65 mb-2 font-weight-bold">
            {{'Descriptionofabsence'| localize}} <span class="text-danger">*</span>


        </div>
        <input type="text" [ngClass]="{'error': !descriptionOfAbsence && isOfflineTimeSubmitted}" class="form-control" required [disabled]="isOfflineTimeApproved" [(ngModel)]="descriptionOfAbsence" />
        <div *ngIf="!descriptionOfAbsence && isOfflineTimeSubmitted" class="text-danger">
            <span>{{"Descriptionismandatory" | localize}}</span>
        </div>
    </div>
    <div class="row ">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <div class="text-dark-65 mb-2 font-weight-bold">{{'ProjectName' | localize}} <span class="text-danger">*</span></div>
                        <!-- <app-project-filter #projectFilter [multiselect]="false" [closeOnSelect]="true" [placeholder]="'Select project'" [initId]="initProjectId" (change)="selectProject($event)"></app-project-filter> -->
                        <ng-select [ngClass]="{'error': !sidebarProjectId && isOfflineTimeSubmitted}" [items]="projectList" [multiple]="false" bindLabel="name" bindValue="id" [(ngModel)]="sidebarProjectId" [ngModelOptions]="{standalone: true}" (change)="selectProject($event)" dropdownPosition="bottom" [closeOnSelect]="true" [disabled]="isOfflineTimeApproved" placeholder="{{'Selectproject' | localize}}">
                            <!-- Label template -->
                            <ng-template ng-label-tmp let-item="item">
                                <span class="d-flex align-items-center">
                                    <img height="17" width="17" class="mr-1" [src]="item.projectImage || 'assets/common/images/projects/default image for project -1.png'" />
                                    {{item.name}}
                                </span>
                            </ng-template>
                            <!-- Option template -->
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                <div class="d-flex">
                                    <div class="d-flex justify-content-center align-items-center rounded bg-light mx-1" style="width: 40px; height: 40px;">
                                        <img src="{{ item.projectImage || 'assets/common/images/projects/default image for project -1.png' }}" class="img-fluid">
                                    </div>
                                    <div class="d-flex align-items-start justify-content-center flex-column ml-2 text-dark-75">
                                        <div class="font-weight-bold">
                                            <span pTooltip="{{ item.name }}" [tooltipDisabled]="DisableTooltip(item.name, 15)" tooltipPosition="bottom">{{ item.name | slice:0:15 }}{{item.name?.length > 15 ? '...' : ''}}</span>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </ng-select>
                        <div *ngIf="!sidebarProjectId && isOfflineTimeSubmitted" class="text-danger">
                            <span>{{"Projectismandatory" | localize}}</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group mb-5">
                        <div class="text-dark-65 mb-2 font-weight-bold">{{'TaskCategory' | localize}} <span class="text-danger">*</span></div>
                        <ng-select [items]=" jobs"
                        [multiple]="false" [clearable]="false"
                        bindLabel="name" [disabled]="isOfflineTimeApproved"
                        class="border-1 rounded-2"
                        [ngClass]="{'border-danger':  (jobName.invalid && jobName.errors.required) }"
                        bindValue="id"  id="jobName" name="jobName" #jobName="ngModel" required
                        [clearSearchOnAdd]="true"
                        [(ngModel)]="SelectedTaskCategoryId"
                        (change)="onJobChange($event)"
                        placeholder="{{ 'SelectTaskCategory' | localize }}"
                       ></ng-select>
                        <div *ngIf="!SelectedTaskCategoryId && isOfflineTimeSubmitted" class="text-danger">
                            <span>{{'Taskismandatory' | localize}}</span>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="form-group">
            <div class="text-dark-65 mb-2 font-weight-bold">{{'TaskName' | localize}} <span class="text-danger">*</span></div>
            <ng-select [ngClass]="{'error': !selectedTaskId && isOfflineTimeSubmitted}" [items]="taskMenu" [(ngModel)]="selectedTaskId" [disabled]="isOfflineTimeApproved" [multiple]="false" bindLabel="name" bindValue="id" [closeOnSelect]="true" placeholder="{{'Selecttask' | localize}}">
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" class="ps">
                    <div class="d-flex">
                        <div class="d-flex align-items-start justify-content-center flex-column ml-2 text-dark-75">
                            <div class="font-weight-bold team-label-name">
                                <span pTooltip="{{ item.name }}" [tooltipDisabled]="DisableTooltip(item.name, 60)" tooltipPosition="bottom">{{ item.name | slice:0:60 }}{{item.name?.length > 60 ? '...' : ''}}</span>

                            </div>
                        </div>
                    </div>
                </ng-template>
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of items | slice: 0:2">
                        <span class="ng-value-label" pTooltip="{{ item.name }}" [tooltipDisabled]="DisableTooltip(item.name, 15)" tooltipPosition="bottom">{{ item.name | slice:0:15 }}{{item.name?.length > 15 ? '...' : ''}}</span>
                        <!-- <span class="ng-value-label">{{ item.taskName }}</span> -->
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 2">
                        <span class="ng-value-label">{{ items.length - 2 }} {{'More' | localize}}...</span>
                    </div>
                </ng-template>
            </ng-select>
            <div *ngIf="!selectedTaskId && isOfflineTimeSubmitted" class="text-danger">
                <span>{{'Taskismandatory' | localize}}</span>
            </div>
        </div>
    </div>
    <div class="text-dark-65 mb-2 font-weight-bold mb-3">{{'Productivity' | localize}} <span class="text-danger">*</span></div>
    <!--<div class="row mb-1 border border-secondary mx-0" [ngClass]="{'error': !productivityType && isOfflineTimeSubmitted}">
        <div class="col-4 border-right pointer sidebar-prod-type-container" [ngClass]="{'selected-type': productivityType && productivityType === 1}" (click)="productivityType = 1">
            <div class="d-flex mx-4 align-items-center py-3">
                <div class="legend-badge productive-legend-badge"></div>
                <div class="text-dark-65 ml-4 font-size-sm">{{'Productive' | localize}}</div>
            </div>
        </div>
        <div class="col-4 border-right border-secondary pointer sidebar-prod-type-container" [ngClass]="{'selected-type': productivityType && productivityType === 2}" (click)="productivityType = 2">
            <div class="d-flex  align-items-center py-3">
                <div class="legend-badge unproductive-legend-badge"></div>
                <div class="text-dark-65 ml-4 font-size-sm">{{'Unproductive' | localize}}</div>
            </div>
        </div>
        <div class="col-4 pointer sidebar-prod-type-container" [ngClass]="{'selected-type': productivityType && productivityType === 3}" (click)="productivityType = 3">
            <div class="d-flex mx-4 align-items-center py-3">
                <div class="legend-badge neutral-legend-badge"></div>
                <div class="text-dark-65 ml-4 font-size-sm">{{'Neutral' | localize}}</div>
            </div>
        </div>
    </div>-->


    <div class="btn-group-toggle btn-productivity-group d-flex flex-column flex-sm-row" data-toggle="buttons" [ngClass]="{'error': !productivityType && isOfflineTimeSubmitted, 'pointer-events-none': isOfflineTimeApproved}">
        <label class=" align-items-center btn btn-productive d-flex justify-content-center mb-sm-0 ml-0 rule-1 w-100 py-3"
               [ngClass]="{'': isViewProductive, 'font-weight-bolder backProductiveColor': isViewProductive && productivityType === 1}"
               (click)="viewProductive() ; productivityType = 1">
            <div class="indicator"></div>
            <input name="rule" value="1" type="radio" [ngClass]="{'selected-input-1': productivityType === 1}" checked="checked"> {{'Productive' | localize}}
        </label>

        <label class=" btn btn-unproductive ml-0 mb-sm-0 d-flex align-items-center justify-content-center w-100 rule-1 "
               [ngClass]="{'backUnProductiveColor': isViewUnProductive, 'font-weight-bolder': isViewUnProductive && productivityType === 2}"
               (click)="viewUnProductive() ; productivityType = 2">
            <div class="indicator"></div>
            <input name="rule" value="-1" type="radio" [ngClass]="{'selected-input-2': productivityType === 2}"> {{'Unproductive' | localize}}
        </label>

        <label class="btn btn-neutral ml-0 mb-sm-0 d-flex align-items-center justify-content-center w-100 rule-1 "
               [ngClass]="{'backNeutralColor': isViewNeutral, 'font-weight-bolder': isViewNeutral && productivityType === 3}"
               (click)="viewNeutral() ; productivityType = 3">
            <div class="indicator"></div>
            <input name="rule" value="0" type="radio" [ngClass]="{'selected-input-3': productivityType === 3}"> {{'Neutral' | localize}}
        </label>
    </div>
    <div *ngIf="!productivityType && isOfflineTimeSubmitted" class="text-danger">
        <span>{{'Productivitytypeismandatory'|localize}}</span>
    </div>
    <div class="d-flex justify-content-end mt-9">
        <button class="btn btn-outline-danger rounded-0 py-2 px-7 mr-3" (click)="closeSidePanel()">
            {{'Cancel' | localize}}
        </button>
        <button [disabled]="isOfflineTimeApproved" class="btn btn-primary rounded-0 py-2 px-10" (click)="addProductivityData()" *ngIf="!isOfflineTimeApproved">{{'Save' | localize}}</button>
         <button [disabled]="isOfflineTimeApproved" class="btn btn-danger rounded-0 py-2 px-10" (click)="deleteManualTime(true)" *ngIf="!isOfflineTimeApproved && manualTimeIdToDelete !== undefined">{{'Delete' | localize}}</button>
    </div>
</p-sidebar>

